/**
 * Do not edit directly, this file was auto-generated
 */

export const ButtonSizeLarge = "56px";
export const ButtonSizeMedium = "48px";
export const ButtonSizeSmall = "40px";
export const ButtonSizeXsmall = "32px";
export const ButtonSizeMicro = "24px";
export const ButtonColorBackgroundPrimaryDefault = "#000";
export const ButtonColorBackgroundPrimaryHover = "#40384C";
export const ButtonColorBackgroundPrimaryDisabled = "#CACCCD";
export const ButtonColorBackgroundPrimaryDestructive = "#FD7268";
export const ButtonColorBackgroundPrimaryDestructiveHover = "#AE2F2F";
export const ButtonColorBackgroundSecondaryDefault = "#F6F6F7";
export const ButtonColorBackgroundSecondaryHover = "#F0E3FF";
export const ButtonColorBackgroundFlatDefault = "#ffffff00";
export const ButtonColorBackgroundFlatHover = "#F0E3FF";
export const ButtonColorBackgroundFlatActive = "#E5D2FF";
export const ButtonColorTexticonPrimary = "#fff";
export const ButtonColorTexticonSecondary = "#000";
export const ButtonColorTexticonDisabled = "#CACCCD";
export const ButtonColorBorderSecondaryDefault = "#000";
export const ButtonColorBorderSecondaryDisabled = "#CACCCD";
export const ButtonTextLinkLarge = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "20px",
  textDecoration: "underline",
};
export const ButtonTextLinkMedium = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "18px",
  textDecoration: "underline",
};
export const ButtonTextLinkSmall = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "16px",
  textDecoration: "underline",
};
export const ButtonTextLinkXsmall = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "14px",
  textDecoration: "underline",
};
export const ButtonTextLarge = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "20px",
  textDecoration: "none",
};
export const ButtonTextMedium = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "18px",
  textDecoration: "none",
};
export const ButtonTextSmall = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "16px",
  textDecoration: "none",
};
export const ButtonTextXsmall = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "14px",
  textDecoration: "none",
};
export const ButtonTextMicro = {
  fontFamily: "DM Sans",
  fontWeight: 400,
  lineHeight: "16px",
  fontSize: "12px",
  textDecoration: "none",
};
export const ButtonSpaceInline = "8px";
export const ButtonSpaceLarge = "24px";
export const ButtonSpaceMedium = "20px";
export const ButtonSpaceSmall = "16px";
export const ButtonSpaceXsmall = "12px";
export const ButtonSpaceMicro = "4px";
export const ButtonBorderRadiusDefault = "8px";
export const ButtonBorderRadiusCircle = "1000px";
export const ButtonBorderWidthSecondary = "2px";
export const ButtonIconSizeSmall = "20px";
export const ButtonIconSizeMedium = "24px";
export const ButtonIconSizeLarge = "24px";
